import { useEffect } from "react";
import { Link } from "react-router-dom";
import { Tooltip } from "bootstrap";

const HomeFooter = () => {
  const currentYear = new Date().getFullYear();

  useEffect(() => {
    const tooltipTriggerList = document.querySelectorAll(
      '[data-bs-toggle="tooltip"]'
    );

    tooltipTriggerList.forEach(el => {
      new Tooltip(el);
    });
  }, []);

  return (
    <footer className="home-footer">
      {<div className="footer-content">
        <div className="row m-0 p-lg-3 justify-content-center fw-semibold mx-md-3">
          {/* Logo & Tagline - col-xl-3 */}
          <div className="col-12 col-xl-3">
            <div>
              <img
                src="/images/logo_image.webp"
                alt="FMW-logo"
                className="logo-image"
              />
            </div>
            <p className="sub-text">
              "Branding your cause to the
              community just became that much
              easier. Pick one of our Group Apps that
              brands to raise funds."
            </p>
          </div>

          {/* Contact US - col-xl-3 */}
          <div className="col-12 col-sm-6 col-lg-3 col-xl-3 text-lg-center">
            <p className="head">Contact US</p>
            <div className="sub-text">
              <a className="sub-text" href="mailto:support@fundmewiz.com">
                support@fundmewiz.com
              </a>
            </div>
          </div>




          {/* Find Us On - col-xl-1 */}
          <div className="col-12 col-sm-6 col-lg-2 col-xl-1 text-lg-center">
            <p className="head mt-3 mt-sm-0 text-nowrap">Find Us On</p>
            <div className="row mb-2">
              <a
                className="col-2 col-md-2 col-lg-4 col-xl-6 text-lg-center"
                href="https://twitter.com/fundmewiz"
                target="_blank"
                rel="noopener noreferrer"
                data-bs-toggle="tooltip"
                title="X"
              >
                <span className="icon">
                  <i className="fa-brands fa-square-x-twitter"></i>
                </span>
              </a>

              <a
                className="col-2 col-md-2 col-lg-4 col-xl-6 text-lg-center"
                href="https://facebook.com/fundmewiz"
                target="_blank"
                rel="noopener noreferrer"
                data-bs-toggle="tooltip"
                title="Facebook"
              >
                <span className="icon">
                  <i className="fa-brands fa-square-facebook"></i>
                </span>
              </a>

              <a
                className="col-2 col-md-2 col-lg-4 col-xl-6 text-lg-center"
                href="https://linkedin.com/company/fundmewiz"
                target="_blank"
                rel="noopener noreferrer"
                data-bs-toggle="tooltip"
                title="LinkedIn"
              >
                <span className="icon">
                  <i className="fa-brands fa-linkedin"></i>
                </span>
              </a>

              <a
                className="col-2 col-md-2 col-lg-4 col-xl-6 text-lg-center"
                href="https://instagram.com/fundmewiz"
                target="_blank"
                rel="noopener noreferrer"
                data-bs-toggle="tooltip"
                title="Instagram"
              >
                <span className="icon">
                  <i className="fa-brands fa-square-instagram"></i>
                </span>
              </a>

              <a
                className="col-2 col-md-2 col-lg-4 col-xl-6 text-lg-center"
                href="https://tiktok.com/@fundmewiz"
                target="_blank"
                rel="noopener noreferrer"
                data-bs-toggle="tooltip"
                title="TikTok"
              >
                <span className="icon">
                  <i className="fa-brands fa-tiktok"></i>
                </span>
              </a>
            </div>
          </div>

          {/* Download Now - col-xl-2 */}
          <div className="col-12 col-sm-6 col-lg-3 col-xl-2 head text-lg-center">
            <p>Download Now!</p>
            <div className="row justify-content-center">
              <div className="col-12 col-md-10 col-lg-12 col-xl-9">
                <div className="d-flex d-xl-block justify-content-center text-center">
                  <a
                    className="me-2 me-xl-0"
                    href="https://play.google.com/store/apps/details?id=com.fundmewiz"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      src="/images/google_play.webp"
                      alt="google_play"
                      className="download-img mb-3"
                    />
                  </a>
                  <a
                    href="https://apps.apple.com/app/fundmewiz"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      src="/images/app_store.webp"
                      alt="app_store"
                      className="download-img mb-3"
                    />
                  </a>
                </div>
              </div>
            </div>
          </div>

          {/* Landing Pages & Queries - col-xl-3 */}
          <div className="col-12 col-sm-6 col-lg-4 col-xl-3 mt-lg-0 text-lg-center">
            <div className="pt-xl-2">
              <br />
              <Link
                to="/member-landing-page"
                target="_blank"
                style={{ textDecoration: 'underline', color: '#6E6E6E' }}
              >
                Member Landing Page
              </Link>
              <br />
              <Link
                to="/participant-landing-page"
                target="_blank"
                style={{ textDecoration: 'underline', color: '#6E6E6E' }}
              >
                Influencer/Participant Landing Page
              </Link>
              <hr />
            </div>
            <div className="head">
              <p className="mb-0">For any queries</p>
              <p className="mt-3 mt-sm-2 mt-md-3">
                <a className="head" href="mailto:info@fundmewiz.com">
                  Email: <i className="fa-regular fa-envelope"></i> info@fundmewiz.com
                </a>
              </p>
            </div>
          </div>
        </div>

        {/* Footer Bottom */}
        <div className="footer-end pt-3 d-md-flex m-0 justify-content-evenly sub-text fw-semibold">
          <div className="ms-lg-3 ms-xl-5 mb-1 mb-lg-0">
            © {currentYear} All Rights Reserved by FundMeWiz, LLC.
          </div>
          <div className="me-lg-3 me-xl-5">
            <Link to="/terms-of-use" target="_blank" className="sub-text">Terms of Use</Link>
            {' / '}
            <Link to="/privacy-policy" target="_blank" className="sub-text">Privacy Policy</Link>
            {' / '}
            <Link to="/about-us" target="_blank" className="sub-text">About FundMeWiz</Link>
          </div>
        </div>
      </div>
}
    </footer>
  );
};

export default HomeFooter;
